import nf from '../../assets/js/nationalFlag'
import { post } from "../../assets/js/request"
export default {
    data() {
        return {
            loading: false,
            date_current: '', //系统当前日期
            curryear: '', //系统当前年份
            currmonth: '', //系统当前月份
            currday: '', //系统当前日
            yeartext: '2022年',
            months: ['2022-01', '2022-02', '2022-03', '2022-04', '2022-05', '2022-06', '2022-07', '2022-08', '2022-09', '2022-10', '2022-11', '2022-12'], //月份列表
            month_selected: '', //所选月份
            monthInfo: [], //所选月份的天数信息
            weeks: ['周一','周二','周三','周四','周五','周六','周日'], //星期列表
            days: [ //所选月份日期行列表，每行七天为一个数组
                // [{day:''}, {day:''}, {day:''}, {day:''}, {day:''}, {day:''}, {day:'1', date:'2022-05-01', isFestival:true, flags:['China','Malaysia','Singapore']}], 
            ], 
            date_selected: '', //所选日期

            showFestivals: false, //是否显示休市市场
            date_showFestival: '', //展示假期信息的日期
            festivals: [ //选中日期的节日详情
                // {festival_name:'劳动节', area:'中国,马来西亚', market: '1.上证股票 2.深证股票 3.马来西亚BMD', remark:'其它'}
            ], 

            changeday: '', //转折日期，该日期之前显示当年的1月到12月，该日期之后显示当年当月到次年
            festivals_all: [], //全部假期列表，其中每个月份为一个小列表

            //浏览器宽高
            height: 0,
            width: 0,

            info_top: 0,
            info_left: 0,
            info_width: 700,
            info_font: 12,

            th_height: 40,

            itemFlag: false, //鼠标是否在日期格子里
            infoFlag: false, //鼠标是否在悬框中
            hasScrollbarFlag: false, //窗口原本有没有滚动条
        }
    },
    computed: {
        infoStyle() {
            return {
                top: this.info_top + 'px',
                left: this.info_left + 'px',
                width: this.info_width + 'px',
                'font-size': this.info_font + 'px'
            }
        },
        thStyle() {
            return {
                height: this.th_height + 'px',
                'line-height': this.th_height + 'px'
            }
        }
    },
    created() {
        
    },
    mounted() {
        this.initToday()
        let _vm = this
        _vm.calInfoSize()
        window.addEventListener("resize", function(){
            _vm.calInfoSize()
        })
        window.addEventListener("load", function(){
            _vm.calInfoSize()
        })
    },
    methods: {
        //根据浏览器宽度计算悬框宽度以及文字大小
        calInfoSize() {
            //窗口长宽
            this.height = document.documentElement.clientHeight || document.body.clientHeight;
            this.width = document.documentElement.clientWidth || document.body.clientWidth;
            //悬框尺寸
            this.info_width = document.body.clientWidth * 0.37
            this.info_font = this.info_width/680*13
            //表头高度
            this.th_height = this.info_width/680*40

            this.hasScrollbarFlag = this.hasScrollbar()
        },

        //判断窗口现在是否有滚动条
        hasScrollbar() {
            let item = this.$refs.container
            if (item) {
                return item.scrollHeight > item.clientHeight
            }
            return false;
        },

        //获取滚动条宽度
        getScrollbarWidth() {
            var odiv = document.createElement('div'),//创建一个div
                styles = {
                    width: '100px',
                    height: '100px',
                    overflowY: 'scroll'//让他有滚动条
                }, i, scrollbarWidth;
            for (i in styles) odiv.style[i] = styles[i];
            document.body.appendChild(odiv);//把div添加到body中
            scrollbarWidth = odiv.offsetWidth - odiv.clientWidth;//相减
            odiv.remove();//移除创建的div
            return scrollbarWidth;//返回滚动条宽度
        },

        //获取当前日期
        initToday() {
            let today = new Date()
            this.curryear = today.getFullYear()
            this.currmonth = today.getMonth()+1
            this.month_selected = this.formateDate1(this.curryear, this.currmonth)
            this.currday = today.getDate()
            this.date_current = this.formateDate1(this.curryear,this.currmonth,this.currday)
            // this.date_selected_d = this.formateDate1(this.curryear,this.currmonth,this.currday) 

            this.initCalendar(this.curryear, this.currmonth)
            this.getFestivals()
        },

        //获取所选月份信息
        getMonthInfo(year, month) { 
            let index = this.monthInfo.findIndex(el => el.year==year && el.month==month)
            if (index==-1) {
                let daynum = new Date(year, month, 0).getDate()  //获取当月天数
                let sday = new Date(month+'/1'+'/'+year).getDay()-1  //获取当月第一天是星期几，对应weeks的index，-1-星期日
                let eday = new Date(month+'/'+daynum+'/'+year).getDay()-1  //获取当月最后一天是星期几
                this.monthInfo.push({
                    year: year,
                    month: month,
                    daynum: daynum,
                    start: sday==-1 ? 6 : sday,
                    end: eday==-1 ? 6 : eday
                })
                return this.monthInfo[this.monthInfo.length-1]
            }
            return this.monthInfo[index]
        },

        //初始化当月日历
        initCalendar(year, month) {  
            let days = []
            let item = this.getMonthInfo(year, month)
            if (item) {
                for (let j = 0; j < item.start; j++) {
                    days.push({
                        day: '',
                        date: ''
                    })
                }
                for (let j = 1; j <= item.daynum; j++) {
                    let isnow = this.curryear==item.year && this.currmonth==item.month && this.currday==j
                    let date = this.formateDate1(year,month,j)
                    days.push({
                        day: j,
                        date: date,
                        isFestival: false,
                        isNow: isnow
                    })
                    isnow && date==this.date_selected && this.changeDate(days[days.length-1])
                }
                for (let j = 6; j > item.end; j--) {
                    days.push({
                        day: '',
                        date: ''
                    })
                }
            }
            days = this.setDaysInfo(month, days)
            this.groupDays(days)
        },

        //补充每一天的假期等其他信息
        setDaysInfo(month, days) {
            let info = this.festivals_all[month-1]
            if (!info) return days;

            return days.map(el => {
                let arr = info.filter(e => e.festival_date.indexOf(el.date)!==-1)
                if(el.day=='' || arr.length==0) return el;

                let flags = []
                let ids = arr.map(e => {
                    let flist = e.area.split(',').map(ar => nf.getFlag(ar, e.festival_name))
                    flags = flags.concat(flist)
                    return e.id
                })
                flags = [...new Set(flags)]  //去重
                return {...el, isFestival: true, ids: ids, flags: flags}
            })
        },

        //将该月的所有天按行分组
        groupDays(days) {
            if (days) {
                this.days = []
                for (let i = 0; i < 6; i++) {
                    let arr = []
                    for (let j = 0; j < 7; j++) {
                        let el = days[i*7+j]
                        if(!el) break;
                        arr.push(el)
                    }
                    this.days.push(arr)
                }
            }
        },

        //切换月份
        changeMonth(val) {
            if (val!=this.month_selected) {
                this.month_selected = val
                this.date_selected = ''
                this.initCalendar(val.split('-')[0], parseInt(val.split('-')[1]))
                this.showFestivals = false
            }
        },

        //获取地区对应的国旗
        getImgUrl(str) {
            try {
                return require('../../assets/images/'+str+'.jpg')
            } catch (error) {
                return ''
            }
        },

        //日期格式化
        formateDate(string) {
            if(string && string!='') {
                let arr = string.split('-')
                return arr[0]+'年'+parseInt(arr[1])+'月'+parseInt(arr[2])+'日'
            } else {
                return ''
            }
        },
        formateDate1(year,month,day) {
            let m = month<10 ? '0'+month : month
            if (day) {
                let d = day<10 ? '0'+day : day
                return year+'-'+m+'-'+d
            } else {
                return year+'-'+m
            }
         },

        //鼠标进入
        enter(item, e) {
            // console.log(e)
            this.itemFlag = true
            // requestAnimationFrame(() => {
                if(item.date=='') return this.date_selected = '';
                this.date_selected = item.date
                //更换选中日期的节日详情
                if (this.month_selected!='') {
                    this.festivals = []
                    
                    let month = parseInt(this.month_selected.split('-')[1])
                    let list = this.festivals_all[month-1] 
                    list && (this.festivals = list.filter(el => el.festival_date==item.date))
                    //没有其他信息的不显示这一列
                    if (this.festivals.length > 0) {
                        let index = this.festivals.findIndex(el => el.remark.trim() != '')
                        this.festivals[0].showRemark = index !== -1

                        this.showFestivals = true
                        this.setPosition(e.target, e.clientX, e.clientY)
                    } else {
                        this.showFestivals = false
                    }
                }
            // })
        },

        leave() {
            this.itemFlag = false
            let _vm = this
            setTimeout(() => {
                if(!_vm.infoFlag && !_vm.itemFlag) {
                    _vm.showFestivals = false
                    _vm.date_selected = ''
                }
            }, 0)
        },

        //设置悬浮框位置
        setPosition(target, clientx, clienty) {
            let _vm = this
            let l = target.offsetLeft, t = target.offsetTop, h = target.clientHeight, w = target.clientWidth
            let scrollWidth = this.getScrollbarWidth()

            this.$nextTick(() => {
                let infoHeight = _vm.$refs.info.clientHeight
                let infoWidth = _vm.$refs.info.clientWidth
                requestAnimationFrame(() => {
                    //悬浮框宽700
                    if (l + w + infoWidth > _vm.width) {
                        _vm.info_left = l - infoWidth
                    } else {
                        _vm.info_left = l + w
                    }

                    //设置y
                    if(t + infoHeight >= _vm.height - 55) {
                        if (_vm.height - infoHeight - 60 < 65) { //会出现滚动条
                            _vm.info_top = 65
                            //如果本来没有滚动条，由于悬框而出现滚动条，需要重新设置水平位置
                            if (!_vm.hasScrollbarFlag && (l + w + infoWidth <= _vm.width)) {
                                _vm.info_left = l + w - scrollWidth + 8
                            } 
                        } else {
                            _vm.info_top = _vm.height - infoHeight - 60
                        }
                    }
                    else {
                        _vm.info_top = t
                    }
                    _vm.festivals.length > 0 && (_vm.showFestivals = true)
                })
                
            })
        },

        enterInfo(e) {
            this.infoFlag = true
        },

        leaveInfo(e) {
            this.infoFlag = false
            this.showFestivals = false
            this.date_selected = ''
        },

        //请求假期数据
        getFestivals() {
            this.loading = true
            post('/api/Holiday/GetHolidayList').then(res => {
                this.loading = false
                if (res.data) {
                    res.data.changeday && (this.changeday = res.data.changeday)
                    this.dealMonths()
                    // if (res.data.hlist) {
                    //     res.data.hlist.push({
                    //         area: '中国',
                    //         areaids: '1',
                    //         festival_date: '2023-01-27',
                    //         festival_name: '国内无夜盘交易日',
                    //         id: 1300,
                    //         market: '',
                    //         remark: '当晚不进行夜盘交易',
                    //         specific: 0,
                    //         weekday: '星期五'
                    //     })
                    // }
                    res.data.hlist && this.dealData(res.data.hlist)
                }   
            })
        },

        //处理月份栏
        dealMonths() {
            if (this.changeday && this.changeday!='') {
                let date1 = new Date(this.formateDate1(this.curryear,this.currmonth,this.currday))
                let date2 = new Date(this.curryear+'-'+this.changeday)
                if (date1<date2) { //还没到转折日，显示的是当年的1-12月
                    this.yeartext = this.curryear+'年'
                    this.months = Array.from({ length: 12 }, (item, idx) => {
                        let i = idx+1
                        let d = i<10 ? '0'+i : i
                        return this.curryear+'-'+d
                    })
                } else {
                    this.yeartext = this.curryear+'年 - '+(parseInt(this.curryear)+1)+'年'
                    let n = 12-parseInt(this.currmonth)+1
                    let list1 = Array.from({ length: n }, (item, idx) => {
                        let i = idx + parseInt(this.currmonth)
                        let d = i<10 ? '0'+i : i
                        return this.curryear+'-'+d
                    })
                    let list2 = Array.from({ length: 12-n }, (item, idx) => {
                        let i = idx+1
                        let d = i<10 ? '0'+i : i
                        return (parseInt(this.curryear)+1)+'-'+d
                    })
                    this.months = list1.concat(list2)
                }
            } else {
                this.yeartext = this.curryear+'年'
            }
        },

        //处理假期数据
        dealData(hlist) {
            // console.log(hlist)
            this.festivals_all = Array.from({length: 12}, (item, idx) => [])
            //按月份分组
            for (let i = 0; i < this.months.length; i++) {
                let list = hlist.filter(el => el.festival_date.indexOf(this.months[i])!==-1)
                let index = parseInt(this.months[i].split('-')[1])
                this.festivals_all[index-1] = list
            }
            this.initCalendar(this.curryear, this.currmonth) //默认显示当前月份的日历
            this.date_showFestival = this.date_current
        },

        //处理ASCII码表示的换行
        dealASCII(str) {
            return str.replace(/&#13;/g, '<br/>')
            // return str.replaceAll('&#13;', '<br/>')
        },

        //地区换行显示
        dealArea(str) {
            return str.replace(/,/g, '<br/>')
        }
    },
}